import ServerWaitButton from 'Shared/components/ServerWaitButton'
import CopyToClipboardBig from 'Shared/components/CopyToClipboardBig'
import './MembershipCardWidget.scoped.scss'

export default function MembershipCardWidget() {
  const act = useAct()
  const { membershipCardLink, hasGeneratedGoogleMembershipCard } = useSel(s => s.target)
  
  function generateCard() {
    return act.target.generateCard()
  }

  function regenerateGoogleCard() {
    return act.target.regenerateGoogleMembershipCard()
  }

  return (
    <div className="widget">
      <p className="larger bold no-margin-top">Membership Card</p>
      { !membershipCardLink && <p>Generate a membership card for this person</p> }
      { membershipCardLink && <p>Copy the link below to share this person's membership card</p> }

      { !membershipCardLink && <div>
        <ServerWaitButton className='button small primary margin-right' onClick={generateCard}>
          Generate Membership Card
        </ServerWaitButton>
      </div> }

      { membershipCardLink && <div className="card-link-container">
        <CopyToClipboardBig text='Copy' url={membershipCardLink} />
        {hasGeneratedGoogleMembershipCard && <ServerWaitButton className='button small primary' onClick={regenerateGoogleCard}>
          Remotely Refresh Google Membership Card
        </ServerWaitButton>}
      </div> }
    </div>
  )
}
